<template>
  <v-navigation-drawer width="350px" app v-model="value">
    <v-img src="@/assets/leftbar.png"></v-img>
    <v-list link>
      <v-subheader>功能列表</v-subheader>
      <v-list-item-group color="link">
        <v-list-item :to="item.to" v-for="item in menu" :key="item.text">
          <v-list-item-icon>
            <v-icon :color="item.color">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}<v-chip small class="ml-2" dark color="green" v-if="item.new">NEW!</v-chip> </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import auth from "@/router/auth";
export default {
  props: ["drawer"],
  model: {
    prop: "drawer"
  },
  data() {
    return {
      list: [
        {
          color: "blue",
          icon: "mdi-home",
          to: "/",
          text: "首页"
        },
        {
          color: "green",
          icon: "mdi-cloud-upload",
          to: "/user/upload",
          text: "上传公共云黑库"
        },
        {
          color: "pink",
          icon: "mdi-account-circle",
          to: "/user/center",
          text: "用户中心"
        },
        {
          color: "black",
          icon: "mdi-cloud",
          to: "/user/cloud",
          text: "私有云黑库",
          new: true
        },
        {
          color: "primary",
          icon: "mdi-information-outline",
          to: "/about",
          text: "关于"
        }
      ]
    };
  },
  computed: {
    value: {
      get: function() {
        return this.$store.state.leftbar.drawer;
      },
      set: function(value) {
        this.$store.commit("toggleLeftBar", value);
      }
    },
    menu() {
      return this.list.filter(val => {
        return auth.hasPremiss(val.to);
      });
    }
  }
};
</script>

<style></style>
